import React, {Component} from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import RightPanel from "../../component/projectDetail/RightPanel";
import UserFeedback from "../../../commons/UserFeedback";
import {connect} from "react-redux";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";



class ParticipantsFeedbackContainer extends Component {

    constructor(props) {
        super(props);

    }



    render() {
        return (
            <div className="col-md-9">
                <div className="projectinn nothidden projdetailscont pdfeedback">
                    <Banner {...this.props}/>
                    <TopBar {...this.props} />

                    {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}

                    <div className="projdetlswrap">
                        <div className="row">
                            <div className="col-lg-9">
                                <div className="pdfeedbackwrap">
                                    <UserFeedback {...this.props}/>

                                </div>
                        	</div>
                            
                            <RightPanel {...this.props}/>
                             </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        project: state.showAllReducer,
        applications: state.applications
    };
};

export default connect(mapStateToProps, null)(ParticipantsFeedbackContainer);

